import React from 'react';
import { FormattedDate } from 'react-intl';
import Table from 'components/Table';
import Tooltip from 'components/Tooltip';

const SaveSelectionTable = ({ fetching, data = null, selectedSaveID = undefined, onSelectSave }) => {
    const renderPointerCursorRow = (content) => (
        <div style={{ height: '100%', width: '100%', cursor: 'pointer' }}>{content}</div>
    );

    const renderTimestamp = (value) =>
        renderPointerCursorRow(
            <Tooltip
                title={
                    <FormattedDate
                        value={value}
                        weekday="short"
                        day="2-digit"
                        month="short"
                        year="numeric"
                        hour="2-digit"
                        minute="2-digit"
                        second="2-digit"
                    />
                }
            >
                <span>
                    <FormattedDate
                        value={value}
                        day="2-digit"
                        month="2-digit"
                        year="numeric"
                        hour="numeric"
                        minute="numeric"
                    />
                </span>
            </Tooltip>,
        );

    return (
        <Table
            dataSource={data}
            loading={fetching}
            rowSelection={{
                type: 'radio',
                selectedRowKeys: [selectedSaveID],
                onChange: (selectedRowsKeys) => onSelectSave(selectedRowsKeys[0]),
            }}
            rowKey="id"
            onRow={(record) => ({
                onClick: () => {
                    onSelectSave(record.id);
                }, // click row
            })}
            pagination={{
                hideOnSinglePage: true,
            }}
        >
            <Table.Column
                editable
                title="name"
                dataIndex="name"
                render={(value, record) => {
                    let content = value;
                    if (record.draft) content = <i>{value} (draft) </i>;
                    return renderPointerCursorRow(
                        <Tooltip title={content}>
                            <div
                                style={{
                                    width: `20em`,
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {content}
                            </div>
                        </Tooltip>,
                    );
                }}
            />
            <Table.Column
                title="Description"
                dataIndex="description"
                render={(value) =>
                    renderPointerCursorRow(
                        <Tooltip title={value}>
                            <div
                                style={{
                                    width: `15em`,
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {value}
                            </div>
                        </Tooltip>,
                    )
                }
            />
            <Table.Column title="Created" dataIndex="createdTs" render={renderTimestamp} />
            <Table.Column title="Last modified" dataIndex="lastModifiedTs" render={renderTimestamp} />
        </Table>
    );
};

export default SaveSelectionTable;
